<div class="wizard-container">
    <div class="wizard">
        <div class="wizard-header">
            <h3>Activate Account</h3>
            <button class="mat-button close-btn" aria-label="close wizard" (click)="cancel()">
                <mat-icon class="close-icon">close</mat-icon>
            </button>
        </div>
        <div class="wizard-content">
            <p>Activate the account by selecting a service plan and special features to facilitate customizing the system.</p>
            <mat-vertical-stepper
                #activeAccountStepper
                linear
                class="clare-wizard-stepper redesign-create-wizard-stepper"
                (selectionChange)="onTabSelectionChange($event)"
            >
                <!-- service plan and features -->
                <ng-container *letVar="servicePlanStepIndex as stepIndex">
                    <ng-container *ngIf="stepIndex >= 0">
                        <mat-step [completed]="steps[stepIndex].isCompleted" *letVar="servicePlanStepIndex as stepIndex">
                            <ng-template matStepLabel>
                                <div class="stepper-header">
                                    {{ steps[stepIndex].text }}
                                    <div class="step-header-action" *ngIf="steps[stepIndex].isActive">
                                        <a *ngIf="!isMobile" class="link-button compare-plans" (click)="onComparePlans($event)"
                                            >Compare Plans</a
                                        >
                                    </div>
                                </div>
                            </ng-template>
                            <app-service-plan-options
                                [project]="project"
                                [currentPlan]="updatedFeature.selectedPlan"
                                [selectedPlan]="updatedFeature.selectedPlan"
                                [activeView]="activeView"
                                [subscription]="subscription"
                                [isInWizard]="true"
                                [isCompareBtnHidden]="true"
                                (fieldsChange)="onFieldsChange($event)"
                            ></app-service-plan-options>
                            <div class="divider"></div>
                            <div class="step-action">
                                <button mat-stroked-button class="next-btn" (click)="onSaveSPAndNext()" color="primary">
                                    {{ "Next" | lastStepBtn: "Done":stepIndex:steps }}
                                </button>
                            </div>
                        </mat-step>
                    </ng-container>
                </ng-container>

                <!-- activate LTE step -->
                <ng-container *letVar="activateLTEStepIndex as stepIndex">
                    <ng-container *ngIf="stepIndex >= 0">
                        <mat-step *ngIf="steps[stepIndex]" [completed]="steps[stepIndex].isCompleted">
                            <ng-template matStepLabel>
                                <div class="stepper-header">{{ steps[stepIndex].text }}</div>
                            </ng-template>
                            <clare-enable-lte-step
                                *ngIf="steps[stepIndex].isTouched"
                                [cellularDevice]="cellularDevice"
                                [chSecurityDevice$]="chSecurityDevice$"
                                [isComplete]="isEnableLteStepComplete"
                                [isLteDisabled]="isLteDisabled"
                                [project]="project"
                                [skip]="!isLteSupported"
                                (enableCellularTriggering)="onEnableCellularTrigger($event)"
                                (done)="finishEnableLTE()"
                                (fetchCellularDevice)="onFetchCellDevice()"
                                (processingActivate)="inProcessingActivate()"
                                (fetchChSecurityDevice)="fetchChSecurityDevice(uuid)"
                                (updateFailed)="onUpdateFailed()"
                            ></clare-enable-lte-step>
                            <div class="divider"></div>
                            <div class="step-action">
                                <button
                                    mat-stroked-button
                                    class="next-btn"
                                    color="primary"
                                    [disabled]="!skipWaitingActivateLTE"
                                    (click)="finishEnableLTE()"
                                >
                                    Next
                                </button>
                            </div>
                        </mat-step>
                    </ng-container>
                </ng-container>

                <!-- review contact info step -->
                <ng-container *letVar="reviewContactStepIndex as stepIndex">
                    <ng-container *ngIf="stepIndex >= 0">
                        <mat-step *ngIf="steps[stepIndex]" [completed]="steps[stepIndex].isCompleted">
                            <ng-template matStepLabel>
                                <div class="stepper-header">{{ steps[stepIndex].text }}</div>
                            </ng-template>
                            <app-contact-info-step
                                [project]="project"
                                [customer]="customer"
                                [entity]="entity"
                                (navigateEditUser)="onNavigateEditUser()"
                            ></app-contact-info-step>
                            <div class="divider"></div>
                            <div class="step-action">
                                <button *ngIf="!customer?.id" mat-stroked-button class="skip-btn" (click)="finishWizard()">Skip</button>
                                <button
                                    mat-stroked-button
                                    class="next-btn"
                                    *ngIf="customer?.id"
                                    (click)="finishReviewContactSteps(stepIndex)"
                                    color="primary"
                                >
                                    Next
                                </button>
                            </div>
                        </mat-step>
                    </ng-container>
                </ng-container>

                <!-- configurate MS step -->
                <ng-container *letVar="configureMSStepIndex as stepIndex">
                    <ng-container *ngIf="stepIndex >= 0">
                        <mat-step *ngIf="steps[stepIndex]" [completed]="steps[stepIndex].isCompleted">
                            <ng-template matStepLabel>
                                <div class="stepper-header">{{ steps[stepIndex].text }}</div>
                            </ng-template>
                            <ng-container *ngIf="uuid">
                                <div
                                    *ngIf="isCheckedClare"
                                    class="wrapped-label-checkbox toggle-service"
                                    [ngClass]="{ showMonitoringService: !ignoreMonitoringService }"
                                >
                                    <mat-checkbox (change)="toggleSetupMonitoringService($event)"></mat-checkbox>
                                    <label for="noMonitoringService">
                                        Central station account information not available, monitoring services will be configured at a later
                                        date.</label
                                    >
                                </div>
                                <app-configure-monitoring-service-step
                                    *ngIf="isCheckedClare; else monitoringServiceNotAvailable"
                                    [project]="project"
                                    [isProjectOnline]="isProjectOnline"
                                    [entity]="entity"
                                    [isClareOne]="isClareOne"
                                    [ignoreMonitoringService]="ignoreMonitoringService"
                                    (updateComplete)="finishWizard()"
                                >
                                </app-configure-monitoring-service-step>
                            </ng-container>
                            <div class="divider"></div>
                            <div class="step-action">
                                <button mat-stroked-button class="next-btn" color="primary" (click)="finishWizard()">Done</button>
                            </div>
                        </mat-step>
                    </ng-container>
                </ng-container>
            </mat-vertical-stepper>
        </div>
    </div>
</div>

<ng-template #monitoringServiceNotAvailable>
    <div>Mornitoring Service is not available now!</div>
</ng-template>

<ng-template #comparePlanBox>
    <app-service-plan-options
        [project]="project"
        [currentPlan]="updatedFeature.selectedPlan"
        [selectedPlan]="updatedFeature.selectedPlan"
        [activeView]="compareView"
        [subscription]="subscription"
        [isCompareBtnHidden]="true"
        [isBackOnSelectIgnore]="true"
        (fieldsChange)="onFieldsChange($event, true)"
    ></app-service-plan-options>
</ng-template>
